import { SaveOutlined } from "@ant-design/icons"
import { Button, Space } from "antd"
import { useTranslation } from "react-i18next";

export const DrawerFormButtons = ({ disabled, close, loadingButton, formId }) => {
    const { t } = useTranslation();

    return (
        <Space className="drawerButtons">
            <Button
                form={formId}
                loading={loadingButton}
                icon={<SaveOutlined />}
                type="primary"
                htmlType="submit"
                key="submit"
                disabled={disabled}
            >
                {t('general.save')}</Button>

            <Button key="close" onClick={close}>{t('general.close')}</Button>
        </Space>
    )
}